<template>
  <div id="content" class="candidate_pool_main">
      <AddCommentModal :dialogVisible='dialog' @close="closeModal()" @newValueIsProposed="setNewValueComment($event)" formName="Add a comment" ></AddCommentModal>
      <AddPool :dialogVisible='dialogNewPool' @close="closeModalPool()" @newValueIsProposed="setNewPool($event)" formName="Specify the innovators you are interested in (leave blank otherwise)" ></AddPool>
      <AddToListModal :searchfield="sf" :dialogVisible='dialogList'  @close="closeModalList()" @toExisting="toExisting($event)" @toNew="toNewList($event)"></AddToListModal>




    <div class="container" >
      <div class="all_candidates_download_zone " v-if="!isAssess">
        <div class="col-12 text-center">
          <span class="title">Long list</span>
          <span class="description"></span>

          <LongListUploader :dialogVisible='dialogFullSetFile' @close="dialogFullSetFile=false" @fileUploaded="setLongList()"  :search_field="this.$route.params.search_field_id"></LongListUploader>
        </div>
      </div>
      <div class="col-12 action_zone">
        <span class="actionZoneTitle">CHOOSE YOUR ACTION </span>
       <!-- <router-link class="prev_step_btn_small" v-if="selected_filters.length > 0" :to="'/startup_with_filters_graph/'+this.$route.params.search_field+'/'+JSON.stringify(selected_filters)+'/'+this.$route.params.pid">Graph view</router-link> -->
       <div class="goRight">
         <div class="quicksearch">
             <input type="text" class="input" placeholder="Search by name"  v-model="quicksearch">
         </div>
         <div class="zoneBtn" >
           <button type="button" class="action_btn" name="button" @click="openModalList" >Create a new list</button>

         </div>
       </div>

     </div>
      <div class="candidate_pool">

        <div class="onePool mt50"  v-for="(pool, p) in startups_quicksearch" :key="p">


        <div class="col-12 text-center">
          <span class="title">Candidate pool {{pool.name}}<span v-if='pool.isLongList'><br/>Long List</span></span>
                    <p v-if="pool.comments">{{pool.comments}}</p>
        </div>
        <div class=" ">
          <div class="row list_startup_in_pool">
            <div class="col-12 col-md-6 col-xl-4 candidate" v-for="(candidate, c) in pool.candidates" :key="c">
                    <div class="candidate_card" >
                      <div class="candidate_card_head">
                        <span class="name">{{candidate.name}}</span>

                        <div class="goRight">
                          <button type="button"  class="btn btn-danger" name="button" @click="removeFromPool(pool,candidate)">Remove</button>
                        </div>
                      </div>
                      <div class="candidate_info_content">

                        <StartupCardInner v-if="candidate.company_type?.value?.toUpperCase() == 'STARTUP'" :candidate="candidate"/>
                        <NonStartupCardInner v-else :candidate="candidate"/>


                      </div>
                        <div class="website" v-if="candidate.website">
                           <a :href="candidate.website" target="_blank">{{candidate.website.replace(/^https?:\/\//, '').replace(/\/$/, '')}}</a>
                        </div>
                      <div class="footer">
                        <div class="showComments" @click='openModal(candidate)' >
                          <img :src="require('@/assets/comments.svg')" alt="">
                          <span class="nb_item_comments">{{candidate.comments.length}}</span>
                        </div>

                        <router-link :to="'/expert/startup/'+candidate._id.$oid+'/'+this.$route.params.projectid"  v-if="candidate._id" >
                        Details  <svg class="arrow-icon" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
                          <g fill="none" stroke="#4c81c0" stroke-width="1.5" stroke-linejoin="round" stroke-miterlimit="10">
                            <path class="arrow-icon--arrow" d="M16.14 9.93L22.21 16l-6.07 6.07M8.23 16h13.98"></path>
                          </g>
                        </svg>
                        </router-link>
                      </div>


                          </div>
            </div>
          </div>
          <!-- <table class="table poolTab">
            <tr v-for="(candidate, c) in pool.candidates" :key="c">
              <td class="startupImg">
                <img :src="this.apiUrl+'/get_image/'+candidate.image.$oid+'?token='+$store.state.innotoken" class="candidate_image_small" alt="" v-if="candidate.image">
                <img src="https://www.innopearl.ch/wp-content/uploads/2022/12/inn_header-accelerator.jpg" class="candidate_image_small" alt="" v-else>
              </td>
              <td  class="startupName">
                <span class="candidate_name">{{candidate.name}}</span>

                <span class="candidate_desc">{{candidate.short_desc}}</span>
                <div class="alert alert-danger" v-if="candidate.needsReview == true">
                  <router-link :to="'/admin/startup/'+candidate._id.$oid+'/'+project._id.$oid" >A new startup uploaded by the customer. Please review and complete the startup's profile.</router-link>
                </div>
                <div class="candidate_links candidate_comments" style="">
                  <div >


                  <small>Comment<span v-if="candidate.comments.length > 1">s</span></small>
                  <div class="comments_list">
                      <div class="one_comment" v-for="(comment, i) in candidate.comments" :key="i">
                        <span v-if="comment.value"> <strong v-if="comment.by">{{comment.by}} : </strong><span v-html="comment.value"></span></span>
                            <span v-else>{{comment}}</span>
                      </div>

                  </div>
                      </div>
                  <div class="add_comment col-12 text-right">
                      <button type="button" class="add_new_comment" @click='openModal(candidate)' name="button">
                        <img :src="require('@/assets/comments.svg')" alt="">
                        Add a comment</button>
                  </div>
                </div>
              </td>
              <td  class="startupAction">
                <div class="btnContainer">
                  <router-link :to="'/admin/startup/'+candidate._id.$oid+'/'+project._id.$oid"  v-if="candidate._id" target="_blank" class="btn btn-primary"><img :src="require('@/assets/eye.svg')" alt="" class="left">
                  Details
                  </router-link>
                  <button type="button"  class="btn btn-danger" name="button" v-if="pool.isAdminSubmit != true" @click="removeFromPool(pool,candidate)">Remove from the pool</button>
                </div>

              </td>
            </tr>
          </table> -->
          <div class="addNewStartup col-12 text-center" >

            <button type="button" name="button" class="addNewStartToogler" @click="showNewStartup = !showNewStartup">
              <img :src="require('@/assets/plusbleu.svg')" alt="" class=" ">
              ADD A NEW INNOVATOR TO THE POOL
            </button>

            <div class="addNewStartup_content" v-if="showNewStartup">
                <v-autocomplete v-model="startup_to_add" closable-chips  :items="startup_dispo" item-color="#FFF" item-title="name" item-value="_id.$oid"  ></v-autocomplete>
                <button type="button" class="prev_step_btn"  name="button" @click="cancelAdd()">Cancel</button>
                <button type="button" class="next_step_btn"  name="button" @click="addToPool(pool)">Add</button>
                <div class="row">
                  <div class="col-12 mt20">
                    <div class="alert alert-info">You don't find the innovator,
                      <button type="button" class=""  name="button" @click="dialogCreateStartup=true">click here to create a new innovator</button>
                    </div>
                  </div>
                </div>
            </div>
          </div>
        </div>
        <div class="row row_center text-center mt20">
          <button type="button" name="button" class="next_step_btn submitPool" @click='submitPool(pool)' v-if="pool.isAdminSubmit != true && pool.candidates.length >= 1">
            Notify customer
            <img :src="require('@/assets/next.svg')" alt="">
          </button>
        </div>


        </div>


        <div class="selection" >
          <!-- <div class="col-12 text-center mt50" v-if="selection_done != true">
            <div class="row row_center text-center" >
              <button type="button" name="button" class="next_step_btn" @click='addPool()'>
                ADD A NEW POOL
                <img :src="require('@/assets/next.svg')" alt="">
              </button>
            </div>

          </div> -->
          <div class="col-12 text-center mt50" v-if="selection_done == true">
            <router-link type="button" name="button" class="prev_step_btn" :to='"/admin/project/"+project._id.$oid'>
              <img :src="require('@/assets/prev.svg')" alt="">
              BACK TO DASHBOARD

            </router-link>
          </div>
        </div>

      </div>
    </div>

    <NewValueModal :dialogVisible='dialogCreateStartup' @close="dialogCreateStartup=false" @newValueIsProposed="createStartup($event)" formName="Create a new innovator" ></NewValueModal>


  </div>
</template>
<script>
import exportFromJSON from "export-from-json";
import { toast } from 'vue-sonner'
import api from '@/tools/api';
 // import AddCommentModal from '@/components/modals/addComment.vue'
 import AddPool from '@/components/modals/addPool.vue'
  import LongListUploader from '@/components/LongListUploader.vue'
 import NewValueModal from '@/components/modals/addValue.vue'


 import AddCommentModal from '@/components/modals/addCommentWithList.vue'
import StartupCardInner from '@/components/StartupCardInner.vue'
import NonStartupCardInner from '@/components/NonStartupCardInner.vue'

 import AddToListModal from '@/components/modals/addToListShort.vue'


export default {
  components: {
    AddCommentModal,
    AddPool,
    LongListUploader,
    StartupCardInner,
   NonStartupCardInner,
    NewValueModal,
    AddToListModal
  },
  data() {
    return {
      apiUrl: process.env.VUE_APP_API_URL,
      dialog: false,
      quicksearch: "",
      sf: null,
      dialogList: false,
      dialogNewPool: false,
      showNewStartup: false,
      dialogFullSetFile: false,
      isAssess: false,
      startup_dispo : [],
            dialogCreateStartup: false,
      startup_to_add: null,
      pageInfo: {
        mainTitle : "Scouting space",
        subTitle : "View and complete candidates' profiles",
      },
      scouting_challenge : {
        isSubmit : false
      },
      candidateForComments : null,
      project: {},
      candidatespool: [],
      startups_quicksearch: [],
    }
  },
  methods:{
    gobackrouter : function(){
      this.$router.go(-1);
    },
    openModal(candidate){
      this.candidateForComments = candidate;
      this.dialog = true;
    },
    openModalPool(){
      this.dialogNewPool = true;
    },
    closeModal(){
      this.candidateForComments = "";
      this.dialog = false;
    },
    closeModalPool(){
      this.dialogNewPool = false;
    },
    setNewValueComment(v){
      if(v){
        api.post(process.env.VUE_APP_API_URL+"/restrict/search_field/candidate/add_comment",
        {
          comment : v,
          candidate : this.candidateForComments,
        },
        {
          headers: {
              'Content-Type': 'application/json',
        }
      }).then( (r) => {
        console.log(r);
        toast.success("Your comment is added");
          this.candidateForComments.comments.push(r.data);
          this.candidateForComments = null;
      }).catch( () => {
          this.candidateForComments = null;
          toast.error("Sorry an error occurs !")
      });

      }

      this.dialog = false;
    },
    createStartup(val){
      console.log(val);
      if(val){
        api.post(process.env.VUE_APP_API_URL+"/restrict/create_startup",
          {
            name : val,
          },
          {
            headers: {
                'Content-Type': 'application/json',
          }
        }).then( (r) => {
          console.log(r.data);
          this.$router.push('/admin/startup/'+r.data.$oid+'/'+this.project._id.$oid)
        }).catch( () => {
            toast.error("Sorry an error occurs !")

        });
      }
      this.dialogCreateStartup = false;

  },
    setNewPool(v){
      if(v){
        //post to backend with v info
          toast("A new pool has been asked to our team. We will propose it soon. You provide the following information : "+v);
      }
      else{
        toast("A new pool has been asked to our team. We will propose it soon. You don't specify extra information about this new pool");
      }
            this.dialogNewPool = false;
    },
    cancelAdd(){
      this.showNewStartup = false;
      this.startup_to_add = {};
    },
    addToPool(pool){
      var top = {
        'pool' : pool._id.$oid,
        'candidate': this.startup_to_add
      };
      api.post(process.env.VUE_APP_API_URL+"/restrict/search_field/add_candidate_to_pool",top,  {
          headers: {
              'Content-Type': 'application/json',
        }
      }).then(
        (r) => {
          console.log('AFTER ADD TO POOL');
          console.log(r.data);
          api.get(process.env.VUE_APP_API_URL+"/search_field/admin_candidates_pool/"+this.$route.params.search_field_id).then( (r) => {
            // var b = _.merge(this.project.business_challenge, JSON.parse(r.data.business_challenge))
            // console.log();
            // var temp = _.merge(this.candidatespool, r.data)
            console.log(r.data);
            this.scouting_challenge = r.data.scouting_challenge;
            this.project = r.data.project;
            //console.log(this.scouting_challenge);
            this.candidatespool = r.data.list_of_pools;
            this.startups_quicksearch =  r.data.list_of_pools;

          }).catch( (e) => {
            console.log(e);
             toast.error("Sorry an error occurs !")
        });
          this.startup_to_add =null;
        }
      ).catch( (e) => {
        console.log(e);
      })
    },
    removeFromPool(pool,candidate){
      console.log(candidate);
      var top = {
        'pool' : pool._id.$oid,
        'candidate': candidate._id.$oid
      };
      api.post(process.env.VUE_APP_API_URL+"/restrict/search_field/remove_candidate_from_pool",top,  {
          headers: {
              'Content-Type': 'application/json',
        }
      }).then(
        (r) => {
          console.log(r);
          api.get(process.env.VUE_APP_API_URL+"/search_field/admin_candidates_pool/"+this.$route.params.search_field_id).then( (r) => {
            // var b = _.merge(this.project.business_challenge, JSON.parse(r.data.business_challenge))
            // console.log();
            // var temp = _.merge(this.candidatespool, r.data)
            console.log(r.data);
            this.scouting_challenge = r.data.scouting_challenge;
            this.project = r.data.project;
            //console.log(this.scouting_challenge);
            this.candidatespool = r.data.list_of_pools;
            this.startups_quicksearch =  r.data.list_of_pools;

          }).catch( (e) => {
            console.log(e);
             toast.error("Sorry an error occurs !")
        });
        }
      ).catch( (e) => {
        console.log(e);
      })
    },
    submitPool(pool){
      api.post(process.env.VUE_APP_API_URL+"/restrict/search_field/submit_pool",{
        pool : pool,
        search_field : this.$route.params.search_field_id
      },  {
          headers: {
              'Content-Type': 'application/json',
        }
      }).then(
        (r) => {
          console.log(r);
            toast.success("List / Pool submitted");
          pool.isAdminSubmit = true;
        }
      ).catch( (e) => {
        console.log(e);
      })
    },
      setLongList(){
        this.dialogFullSetFile = false;
        api.get(process.env.VUE_APP_API_URL+"/search_field/admin_candidates_pool/"+this.$route.params.search_field_id).then( (r) => {
          // var b = _.merge(this.project.business_challenge, JSON.parse(r.data.business_challenge))
          // console.log();
          // var temp = _.merge(this.candidatespool, r.data)
          console.log(r.data);
          this.scouting_challenge = r.data.scouting_challenge;
          this.project = r.data.project;
          //console.log(this.scouting_challenge);
          this.candidatespool = r.data.list_of_pools;
          this.startups_quicksearch =  r.data.list_of_pools;

        }).catch( (e) => {
          console.log(e);
           toast.error("Sorry an error occurs !")
      });
      },
    setFullSetFile(val){
      console.log(val);
      if(val){
        //this.scouting_challenge.fullCandidatesList = val;
        this.dialogFullSetFile = false;
        api.get(process.env.VUE_APP_API_URL+"/search_field/admin_candidates_pool/"+this.$route.params.search_field_id).then( (r) => {
          // var b = _.merge(this.project.business_challenge, JSON.parse(r.data.business_challenge))
          // console.log();
          // var temp = _.merge(this.candidatespool, r.data)
          console.log(r.data);
          this.scouting_challenge = r.data.scouting_challenge;
          this.project = r.data.project;
          //console.log(this.scouting_challenge);
          this.candidatespool = r.data.list_of_pools;
          this.startups_quicksearch =  r.data.list_of_pools;

        }).catch( (e) => {
          console.log(e);
           toast.error("Sorry an error occurs !")
      });
      }
    },
    addPool(){
      api.post(process.env.VUE_APP_API_URL+"/restrict/search_field/add_pool",{'searchfield':this.$route.params.search_field_id},  {
          headers: {
              'Content-Type': 'application/json',
        }
      }).then(
        (r) => {
          console.log(r);
          this.candidatespool.push(r.data);
        }
      ).catch( (e) => {
        console.log(e);
      })
    },

    downloadAllCandidates(){
      var data = [];
      const fileName ="candidatespool";

     this.candidatespool.forEach((item,cpi) => {

       item.candidates.forEach((candidate) => {
         var tempo = {};
         tempo["Candidates pool"] = cpi+1;
         tempo["Candidate"] = candidate.name;
         tempo["Candidate description"] = candidate.short_desc;
         tempo["Candidate selection"] = candidate.isSelected;
         data.push(tempo);
       });

     });
     console.log(data);
      const exportType = exportFromJSON.types.csv;

      if (data) exportFromJSON({ data, fileName, exportType });
    },
    askForNewPool(){
      toast("A new pool has been asked to our team. We will propose it soon");
    },
    closeScouting(){
      api.post(process.env.VUE_APP_API_URL+"/restrict/search_field/candidates_pool_close/"+this.$route.params.search_field_id,
          {
              value: this.candidatespool
          },
          {
            headers: {
                'Content-Type': 'application/json',
          }
        }).then( (r) => {
          console.log(r);
          toast.success("Scouting challenge has been closed");
          this.scouting_challenge.selectionIsSubmit = true;
        }).catch( () => {
            toast.error("Sorry an error occurs !")
        });
    },

    submitSelection(){
      if(this.selectedCandidates.length < 1){
        toast.error("Please select at least one candidate for assessment")
      }
      else if(this.selectedCandidates.length > 9){
        toast.error("You can assess a maximum of 9 candidates. You have selected "+this.selectedCandidates.length+" candidates. Please adjust your selection")
      }
      else{
        api.post(process.env.VUE_APP_API_URL+"/restrict/search_field/candidates_pool_submit/"+this.$route.params.search_field_id,
            {
                value: this.candidatespool
            },
            {
              headers: {
                  'Content-Type': 'application/json',
            }
          }).then( (r) => {
            console.log(r);
            toast.success("Candidate selection successfully submit ");
            if(this.scouting_challenge == null)this.scouting_challenge = {};
            this.scouting_challenge.selectionIsSubmit = true;
          }).catch( () => {
              toast.error("Sorry an error occurs !")
          });
      }

    },

    toNewList(v){
      console.log(v);
      api.post(process.env.VUE_APP_API_URL+"/restrict/create_new_list",
          {
            pool_name : v,
            candidates : [],
            searchfield : this.$route.params.search_field_id
          },
          {
            headers: {
                'Content-Type': 'application/json',
          }
        }).then( (r) => {
          console.log("TO NEW LIST",r);
          api.get(process.env.VUE_APP_API_URL+"/search_field/admin_candidates_pool/"+this.$route.params.search_field_id).then( (r) => {
            // var b = _.merge(this.project.business_challenge, JSON.parse(r.data.business_challenge))
            // console.log();
            // var temp = _.merge(this.candidatespool, r.data)
            console.log(r.data);
            this.scouting_challenge = r.data.scouting_challenge;
            this.project = r.data.project;
            this.isAssess = r.data.isAssess;
            //console.log(this.scouting_challenge);
            this.candidatespool = r.data.list_of_pools;
           this.startups_quicksearch =  r.data.list_of_pools;
            api.get(process.env.VUE_APP_API_URL+"/restrict/admin_list_startups/"+this.project._id.$oid).then( (r) => {
              console.log(r.data);
              this.startup_dispo = r.data;
            });

          }).catch( (e) => {
            console.log(e);
             toast.error("Sorry an error occurs !")
        });
          toast.success("List successfully created");
        }).catch( () => {
            toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
        });
      this.dialogList = false;
    },
    openModalList(){
      this.dialogList = true;
    },
    closeModalList(){
      this.dialogList = false;
    },
  },
  mounted(){
     this.$store.commit('UPDATE_PAGE_INFO',this.pageInfo)

     this.sf = this.$route.params.search_field_id;
     api.get(process.env.VUE_APP_API_URL+"/search_field/admin_candidates_pool/"+this.$route.params.search_field_id).then( (r) => {
       // var b = _.merge(this.project.business_challenge, JSON.parse(r.data.business_challenge))
       // console.log();
       // var temp = _.merge(this.candidatespool, r.data)
       console.log(r.data);
       this.scouting_challenge = r.data.scouting_challenge;
       this.project = r.data.project;
       this.isAssess = r.data.isAssess;
       //console.log(this.scouting_challenge);
       this.candidatespool = r.data.list_of_pools;
      this.startups_quicksearch =  r.data.list_of_pools;
       api.get(process.env.VUE_APP_API_URL+"/restrict/admin_list_startups/"+this.project._id.$oid).then( (r) => {
         console.log(r.data);
         this.startup_dispo = r.data;
       });

     }).catch( (e) => {
       console.log(e);
        toast.error("Sorry an error occurs !")
   });
 },
  computed:{
    selectedCandidates: function(){
      var selectedCandidatesTemp = [];
      this.candidatespool.forEach((pool) => {
          pool.candidates.forEach((c) => {
              if(c.isSelected == true)selectedCandidatesTemp.push(c);
          });

      });
      return selectedCandidatesTemp;
    },
    selection_done: function(){
      console.log(this.scouting_challenge);
      if(!this.scouting_challenge) return false;
      else if(this.scouting_challenge.selectionIsSubmit != true) return false
      else return true;
    },

    pools_submited: function(){
      var all = true;
      this.candidatespool.forEach((pool) => {
        if(!pool.isAdminSubmit) all = false;
      });
      return all;
    },

  },
  watch: {
    quicksearch: function(v){
      console.log(v);
        this.startups_quicksearch = this.candidatespool.map(obj => ({
        ...obj,
        candidates: obj.candidates.filter(candidate =>
          candidate.name.toLowerCase().includes(v.toLowerCase())
        )
      }));
   },
  }
}
</script>
<style scoped>
.candidate_pool_main{
  padding-top:50px;
  padding-bottom:50px;
}
.all_candidates_download_zone{
    padding: 50px;
    background: #FFF;
    background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 3px 6px #00000029;
border-radius: 8px;
}

#content .candidate_pool{
  background:#FFF;
  padding:20px;
}
.pool_title{
  font-size:20px;
  font-weight: bold;
  color:#3783C5;
}
.startup_page{
  padding-top:50px;
  padding-bottom: 50px;
  padding: 50px;
}
.content_div{
  /* margin-top:50px;
  margin-bottom: 50px; */
  padding-top:50px;
  padding-bottom:50px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 3px 6px #00000029;
border-radius: 8px;
}
.chart-container {
  position: relative;
}

.next_step_btn,
.next_step_btn:hover{
  background: #3783C5 0% 0% no-repeat padding-box !important;
  box-shadow: 0px 3px 6px #00000029 !important;
  border: 1px solid #3783C5 !important;
  border-radius: 50px;
  opacity: 1;
  padding: 14px 37px;
  color:#FFF;
  margin:5px;
}

.prev_step_btn,
.prev_step_btn:hover{
  border: 1px solid #3783C5;
  border-radius: 50px;
  opacity: 1;
  padding: 14px 37px;
  color:#3783C5;
    margin:5px;
    text-decoration: none;
}

.canvasjs-chart-credit{
  display:none;
}

.mt50{
  margin-top:50px;
}

.candidate{
  margin-top:20px;
  margin-bottom: 20px;
}
.candidate_card{
  border: 2px solid #DDDDDD;
border-radius: 15px;
z-index: 5;
height:100%;
display: flex;
flex-direction: column;
}
.candidate_card .candidate_image{
  width:100%;
  height:200px;
  object-fit: cover;
  z-index: 1;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}


.candidate_card .candidate_links{
  display:flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 20px 5px;

  margin: 0;
}
.candidate_card .candidate_info_content .candidate_name{
  font-size:18px;
  line-height:21px;
letter-spacing: 0px;
color: #3783C5;
text-transform: uppercase;
display:block;
font-weight: 500;
}

.candidate_card .candidate_info_content .candidate_desc{
  font-size:16px;
  line-height:22px;
  margin-top:10px;
  display:block;
  margin-bottom:10px;
}
.candidate_card .candidate_links .details{
  font-size:12px;
  line-height: 15px;
  border-right: 1px solid #DDD;
  display:flex;
  align-items: center;
  text-transform: uppercase;
  color: #3783C5;
  flex: 0.5;

}
.candidate_card .candidate_links .details a{
    text-decoration: none;
}
.candidate_card .candidate_links .details img{
  margin-right:5px;
}
.candidate_card .candidate_links .selectIt{
  font-size:12px;
  line-height: 15px;
  letter-spacing: 0px;
  color: #3783C5;
  text-transform: uppercase;
  flex:0.5;
  align-items: flex-end;

}
.candidate_card .candidate_links .selectIt_fw{
  flex:1;
  align-items: flex-start;
}
.candidate_card .candidate_links .selectIt_fw label{
display:flex;
align-items: center;
gap: 5px;
justify-content: start;
}
.candidate_card .candidate_links .selectIt label{
display:flex;
align-items: center;
gap: 5px;
justify-content: end;
}
.candidate_card .candidate_links .selectIt input{
  width:24px;
  height:24px;
}
.candidate_card .candidate_links .details.noBorder{
  border-right: none;

}


.titre{
  margin-bottom: 20px;
  color: #3783C5;
  text-transform: uppercase;
}


.checkbox {
  cursor: pointer;
  display: flex;
  align-items: center;
  /* margin-bottom:20px; */
}
.checkboxItem{
  margin-bottom: 20px;
}
.checkbox__input {
  position: absolute;
  width: 1.375em;
  height: 1.375em;
  opacity: 0;
  cursor: pointer;
}
.checkbox__input:checked + .checkbox__icon .tick {
  stroke-dashoffset: 0;
}
.checkbox__icon {
  width: 1.375em;
  height: 1.375em;
  flex-shrink: 0;
  overflow: visible;
}
.checkbox__icon .tick {
  stroke-dasharray: 20px;
  stroke-dashoffset: 20px;
  transition: stroke-dashoffset 0.2s ease-out;
}
.checkbox__label {
  margin-left: 0.5em;
}

.filtres{

  padding:0;
}
.filtres_head .customH2{
  display: block;
  width: 100%;
  background: #3783C5;
  color: #FFF;
  padding: 10px;
}
.filtre_list{
  padding:10px;
}


.prev_step_btn_small{
  border: 1px solid #3783C5;
  border-radius: 50px;
  opacity: 1;
  padding: 5px 20px;
  color:#3783C5;
    margin:5px;
    text-decoration: none;
}

.next_step_btn_small, .next_step_btn_small:hover {
  background: #3783C5 0% 0% no-repeat padding-box !important;
  box-shadow: 0px 3px 6px #00000029 !important;
  border: 1px solid #3783C5 !important;
  border-radius: 50px;
  opacity: 1;
  padding: 5px 20px;
  color: #FFF;
  margin: auto;
  display:block;
  margin-top:20px;
  margin-bottom: 20px;
}
.startup_zone_legend{
  align-self: top;
}
.zone_startups{
    align-self: center;
}
.zone_title{
  font-size: 25px;
  color: #3783C5;
  font-weight: 700;
  text-align: center;
  display:block;
  width:100%;
  text-align:center;

}
.zone_number{
  font-size: 16px;
  color: #3783C5;
  font-weight: 700;
  text-align: center;
  display:block;
  width:100%;
  text-align:center;

}

.row.zone{
  padding-bottom: 50px;
  padding-top:50px;
}

.startup_zone_legend.stickit .legend{
  position: sticky;
    top: 50%; /* Adjust the top value as needed */
}

.startup_zone_legend:not(.stickit){
  align-self: center;
}

.alert{
  margin:0;
}



.startup_selection_section{
  position:relative;
  padding-top:50px;
}

.filtre_list{
  display: grid;
    grid-template-columns: auto auto auto;
    grid-template-columns: 1fr 1fr 1fr;
    grid-auto-rows: 100%;
    gap:10px;
}


@media screen and (max-width: 690px){
  .candidate_card .candidate_links{
    flex-direction: column;
    flex-wrap: wrap;
    gap: 20px
  }
  .candidate_pool{
      padding: 20px;
    }
    .candidate_card .candidate_links .details{
      border-right: none;
      border-bottom:1px solid #DDD;
      padding-bottom: 20px;
    }
    .candidate_card .candidate_links .selectIt label{
    display:flex;
    align-items: center;
    gap: 5px;
    justify-content: start;
    flex-direction: row-reverse;
    }
    .filtre_list {
  display: grid;
  grid-template-columns: auto auto auto;
  grid-template-columns: 1fr;
  grid-auto-rows: 100%;
  gap: 10px;
}
}


.candidate_comments{
  padding: 20px 50px;
  border-top: 1px solid #DDD;
  margin-top:auto;
}
.candidate_comments .one_comment{
  margin-top:10px;
  margin-bottom: 10px;
  font-size:12px;
  line-height:15px;
    position:relative;
}
.candidate_comments .one_comment:after {
  content: ""; /* This is necessary for the pseudo element to work. */
     display: block; /* This will put the pseudo element on its own line. */
     margin: 0 ; /* This will center the border. */
     width: 20%; /* Change this to whatever width you want. */
     padding-top: 10px; /* This creates some space between the element and the border. */

     border-bottom: 1px solid #CCC; /* This creates the border. Replace black with whatever color you want. */
}
.candidate_comments small{
  font-size:12px;
}

.add_new_comment{
  font-size:12px;
  line-height:15px;
  color: #3785C5;
  text-transform: uppercase;
  margin-top:20px;
}
.add_new_comment img{
  width: 20px;
  margin-right: 10px;
}


.all_candidates_download_zone{
    padding: 50px;
    background: #FFF;
    background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 3px 6px #00000029;
border-radius: 8px;
margin-bottom:50px;
}


.title{
  font-size: 24px;
  line-height:29px;
letter-spacing: 0px;
color: #3783C5;
text-transform: uppercase;
display:block;
margin-bottom: 10px;
}
.all_candidates_download_zone .description{
  display:block;
  margin-top:10px;
  margin-bottom: 20px;
  width:100%;
}

.next_step_btn{
  background: #3783C5 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #3783C5;
  border-radius: 50px;
  opacity: 1;
  padding: 14px 37px;
  color:#FFF;
  margin:5px;
}
.next_step_btn img.left{
  margin-right:10px;
}
img.goFullWhite{
filter: brightness(0) invert(1);
}

.pool_subtitle{
  font-size: 24px;
  line-height:29px;
letter-spacing: 0px;
color: #3783C5;
display:block;
}
.mb10{
  margin-bottom:10px;
}
.mt20{
  margin-top:20px;
}


/* .selectAll{
  border: 1px solid #CCC;
  border-radius: 50px;
  padding: 5px 20px;
  margin: auto;
    margin-top: auto;
  display: block;
  margin-top: 20px;
} */
.goToRight{

}

.candidate_card_head{
  background: #4c81c0;
  padding: 10px;
  color: #FFF;
  text-transform: uppercase;
  font-weight: bold;
  border-radius: 10px 10px 0px 0px;
  display:flex;
  align-content: center;
    align-items: center;
gap:10px;
min-height: 60px;
}

.candidate_card_head .name{
  flex:1;
}
.score {
  height: 70px;
  width: 70px;
  -webkit-clip-path: polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%);
  clip-path: polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%);
  text-align: center;
  background: #B38D2F;
  color: white;
  font-size:17px;
}

.score::before {
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  content: '';
}
.candidate_card .candidate_info_content{
  padding:20px;
  flex-grow: 1;
}
.footer{
padding-left: 20px;
  padding-right: 20px;
    padding-bottom: 10px;
  font-weight:bold;
  text-transform: uppercase;
  color:#B38D2F !important;
  font-size:14px;
  display:flex;
  flex-wrap:wrap;
  gap:10px;
}

.footer a{
  margin-left: auto;
}
.footer *{
  color:#4c81c0 !important;
  font-size:14px;
}
.filtre_list .zone_input{
  position:relative;
}
.filter_content{
  position: absolute;
  top: calc(100% + 10px);
  z-index: 900;
  border: 1px solid #4c81c0;
  padding: 20px;
  display:flex;
  flex-direction: column;
  width:400px;
  gap:15px;
  background: #FFF;
  left: calc(50% - 200px);
  box-shadow: 2px 3px 10px 2px rgba(0,0,0,0.28);
-webkit-box-shadow: 2px 3px 10px 2px rgba(0,0,0,0.28);
-moz-box-shadow: 2px 3px 10px 2px rgba(0,0,0,0.28);
}

@media screen and (max-width:990px){
  .filter_content{
    left:-20px;
    right:-20px;
    width:350px;
}
}

.filter_content .value_possible{
  max-height:300px;
  overflow: scroll;
}
.filter_content .btn_invert{
  padding:10px;
  color:#4c81c0;
  background:#FFF;
  font-size:12px;
  border-radius: 20px;
  border:1px solid #4C81C0;
}

.filter_content .btn{
  padding:10px;
  background:#4c81c0;
  color:#FFF;
  font-size:12px;
  border-radius: 20px;
    border:1px solid #4C81C0;
}
.filter_content .flexBottom{
  display: flex;
    gap: 10px;
    flex-wrap: wrap;
align-self: end;
  margin-top:auto;
}
.zone_input_header{
  border: 2px solid #4c81c0;
  padding: 10px;
  border-radius: 50px;
  cursor:pointer;
}
.zone_input{
  width:100% !important;
  position:relative;
}


.filtre_list_3{
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  margin-bottom: 20px;
  border-left: 2px solid #CCC;
  padding-left: 20px;
}
.filtre_list_2{
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  margin-bottom: 20px;
  /* justify-content: center;*/
  align-items: center;
  flex-grow:1;
}

.nb_item{
  background: #B38D2F;
  padding: 2px 10px;
  border-radius: 5px;
  font-size: 10px;
  color:#FFF;
  vertical-align: middle;

}
.dflex{
  display: flex;
  gap: 10px;
justify-content: stretch;
}

.checkbox{
  position:relative;
}
.checkbox_hover{
  background:#FFF;
  font-size:10px;
  display:none;
}

.checkboxItem:hover  .checkbox_hover{
  display:block;
}
.onecondition{
  width:100%;
  display:block;
}

.website{
  color:#4c81c0 !important;
  font-size:14px;
  text-align:center;
  margin-bottom:20px;
  font-weight:700;
}

.showComments{
  cursor:pointer;
  position:relative;
}


.sidePannel{
  position: fixed;
  right: 0;
  width: min(100%,500px);
  background: #FFF;
  top: 0;
  height: 100vh;
  z-index: 999;
  overflow: scroll;

}

.oneFilter{
  padding-top: 20px;
  padding-bottom: 20px;
}
.oneFilter:not(:last-child){
  border-bottom: 2px solid #CCC;
}
.oneFilter .filtreName{
  margin-bottom:10px;
  display:block;
  color:#4c81c0;
}
.oneFilter .value_possible{
  max-height:300px;
  overflow: scroll; /* Always show both horizontal and vertical scrollbar */
    scrollbar-width: thin; /* Firefox */
    scrollbar-color: #333 #fff; /* Firefox */
}

.oneFilter .value_possible::-webkit-scrollbar {
      width: 12px; /* Width of the scrollbar */
    }

.oneFilter .value_possible::-webkit-scrollbar-thumb {
      background-color: #333; /* Color of the thumb */
    }
.oneFilter .value_possible::-webkit-scrollbar-track {
      background-color: #fff; /* Color of the track */
    }

    .sidePannel .filters{
      overflow: scroll;
  padding: 30px;
  height: calc(100vh - 100px);
    }

  .sidePannel .create_filters{
    overflow: scroll;
padding: 30px;
height: calc(100vh);
  }
    .footerPannel{
      position: static;
  height: 100px;
  border-top: 2px solid #4c81c0;
  padding:20px;
  text-align:right;
    }

      .footerPannel .btn{
      padding:5px 10px;
      background:#4c81c0;
      color:#FFF;
      font-size:15px;
      border-radius: 20px;
      border:1px solid #4C81C0;
      margin:10px;
    }

    .footerPannel .btn_invert{
    padding:5px 10px;
    color:#4c81c0;
    background:#FFF;
    font-size:15px;
    border-radius: 20px;
    border:1px solid #4C81C0;
    margin:10px;
  }
  .triangle{
    width:15px;
  }

  .triangle.open{
    transform:rotate(180deg);
  }

  .candidate_card.isChecked{
    border-color:#4C81C0;
  }
  .candidate_card.isChecked .checkbox__icon .fond{
    fill:#FFF !important;
  }

  .candidate_card.isAssess{
    border-color:#ad8e41;
  }
  .candidate_card.isAssess .candidate_card_head{
    background:#ad8e41;
  }
.goRight{
  margin-left:auto;
  display:flex;
  flex-wrap:wrap;
  gap:20px;
}
.extraPoolsContainer{
  position:relative;
}
.extraPoolsIcons{
  width:20px;
}
.extraPoolsNumber{
  background: #B38D2F;
  color: #FFF;
  padding: 0px 6px;
  font-size: 10px;
  font-weight: bold;
  border-radius: 5px;
  position: absolute;
  top: -4px;
  right: -10px;
}

.isAssess .extraPoolsNumber{
  color: #B38D2F;
  background: #FFF;
  padding: 0px 6px;
  font-size: 10px;
  font-weight: bold;
  border-radius: 5px;
  position: absolute;
  top: -4px;
  right: -10px;
}
.nb_item_comments{
  background: #B38D2F;
  color: #FFF !important;
  padding: 0px 6px;
  font-size: 10px;
  font-weight: bold;
  border-radius: 5px;
  position: absolute;
  top: -4px;
  right: -10px;
}

.action_zone{
  position: sticky;
    right: 0;
    top: 0;
    background: #4C81C0;
    padding: 20px 50px;
    z-index:889;
    display:flex;
    flex-wrap:wrap;

}
.actionZoneTitle{
  color: #FFF;
  font-weight: bold;
  font-size: 20px;
}

.p-rl-50{
  padding-left:50px;
  padding-right:50px;
}

.action_btn,
.action_btn:hover{
  background: #FFF;
  color: #000;
  padding: 5px 15px;
  font-weight: 600;
  border-radius: 50px;
}
.disabledRlink{
  pointer-events: none;
  opacity:0.8;
}

.zoneBtn{
  position:relative;
  display: flex;

}
.onePool:first-of-type{
  margin-top: 50px !important;
}
.onePool:not(:first-of-type){
  margin-top: 100px !important;
  padding-top: 100px !important;
  border-top: 3px dashed #CCC;
}

.whyDisabled{
  position: absolute;
  background: #EFEFEF;
  padding: 5px;
  width: 120px;
  left: 0px;
  bottom: -5px;
  -webkit-transform: translateY(100%);
  transform: translateY(100%);
  font-size:12px;
  display:none;
}

.enableWhyDisabled:hover .whyDisabled{
  display:block;
}

.hoverInfo{
  position: absolute;
  background: #EFEFEF;
  color:#000 !important;
  padding: 5px;
  width: 120px;
  left: 0px;
  bottom: -5px;
  -webkit-transform: translateY(100%);
  transform: translateY(100%);
  font-size:12px;
  display:none;
}

.extraPoolsContainer:hover .hoverInfo{
  display:block;
}

.filter_content_title{
  text-transform:uppercase;
  font-weight:600;
}

.v-slider-track__background--opacity {
  opacity: 1;
}

.selectAll{
  border: 2px solid #4c81c0;
  padding: 10px 20px;
  border-radius: 50px;
  cursor: pointer;
}



.quicksearch .input{
  max-width: 200px;
    border: 1px solid #fff;
    background: transparent;
    padding: 5px 20px;
    border-radius: 50px;
    outline: none;
    color: #fff;
    font-weight: bold;
    letter-spacing: 1px;
}



.slider_mini_score{
  max-width: 350px;
  min-width: 300px;
}
@media screen and (max-width:990px){
  .quicksearch{
    max-width: 100%;
    width:100%;
    margin-top:20px;
  }
  .quicksearch .input{
    max-width: 100%;
    width:100%;
      border: 1px solid #fff;
      background: transparent;
      padding: 5px 20px;
      border-radius: 50px;
      outline: none;
      color: #fff;
      font-weight: bold;
      letter-spacing: 1px;
  }
  .filtre_list_2{
    width:100%;
    flex:1;
  }
}
</style>
